import React from "react";
import {StoredIndividualization, StoredSpot, StoredTemplate} from "../../../types/Individualization";
import ToggleEye from "../../../components/ToggleEye";
import IconButton from "../../../components/IconButton";
import {faCopy, faEdit, faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import {useIndividualizationContext} from "../../../contexts/individualizationContext";
import {useTranslation} from "react-i18next";
import {useGlobalContext} from "../../../contexts/globalContext";
import {CustomizerContextProvider} from "../../../contexts/CustomizerContext";
import CustomizerPopup from "../../CustomizerPopup";
import cx from "classnames";
import styles from './Overview.module.css';

type IndividualizationListProps = {
    individualizations: StoredIndividualization[]
    toggleVisibility: (individualization_id: number) => void;
    openDeleteModal: (individualization_id: number) => void;
}

const IndividualizationListView: React.FC<IndividualizationListProps> = (
    {
        individualizations,
        openDeleteModal,
        toggleVisibility
    }
) => {
    const { changeStoredIndividualization } = useIndividualizationContext();
    const { t } = useTranslation(['individualization']);
    const { showModal } = useGlobalContext();

    const getSurchargePrice = (element: StoredIndividualization|StoredTemplate|StoredSpot): JSX.Element => {
        if (element.surcharge_price) return <span dangerouslySetInnerHTML={{__html: element.surcharge_price[0]}}/>
        else return <span>0,00€</span>
    }
    const showCustomizer = (individualization: StoredIndividualization) => {
        showModal({
            content: (
                <CustomizerContextProvider individualization={individualization} kArtikel={parseInt(individualization.kArtikel)}>
                    <CustomizerPopup />
                </CustomizerContextProvider>
            ),
            fullscreen: false,
            size: 'lg'
        });
    };

    return (
        <div className={cx(styles['list-container'])}>
            {individualizations.map((individualization) => (
                <div key={individualization.id} className={cx(styles['list-item'], 'd-flex', 'justify-content-between', 'align-items-center')}>
                    <div>
                        {individualization.article ? (
                            <a href={individualization.article.url} target="_blank" className={cx(styles['list-title'])} dangerouslySetInnerHTML={{ __html: individualization.article.cName }} />
                        ) : (
                            <div className={cx(styles['missing-article-hint'])}>
                                {t('overview.articleMissing', { articleId: individualization.kArtikel })}
                            </div>
                        )}
                    </div>
                    <div className={cx(styles, 'd-flex', 'align-items-center')} style={{gap: '1rem'}}>
                        <div className={cx(styles['list-actions'], 'd-flex', 'align-items-center')}>
                            <IconButton
                                icon={faEdit}
                                color="#2f2f2f"
                                title={t('overview.edit')}
                                onClick={() => changeStoredIndividualization(individualization, 3)}
                            />
                            <IconButton
                                icon={faCopy}
                                color="#2f2f2f"
                                title={t('overview.copy')}
                                onClick={() => changeStoredIndividualization(individualization, 4)}
                            />
                            <ToggleEye
                                title={individualization.active ? t('overview.visibilityActive') : t('overview.visibilityInactive')}
                                toggleEye={() => toggleVisibility(individualization.id)}
                                status={individualization.active}
                                border={false}
                            />
                            <IconButton
                                icon={faTrashAlt}
                                color="#2f2f2f"
                                title={t('overview.delete')}
                                onClick={() => openDeleteModal(individualization.id)}
                            />
                        </div>
                        {individualization.article ? (
                            <span onClick={() => showCustomizer(individualization)} className={cx(styles['list-demo'])}>
                            {t('overview.demo')}
                        </span>
                        ) : null}

                    </div>

                </div>
            ))}
        </div>
    );
};

export default IndividualizationListView;